/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useRef, FC } from 'react';
import LineCheckInput from './LineCheckInput';
import { getCookie, deleteCookie, setCookie } from 'cookies-next';
import Success from './Success';
import { Spinner } from 'react-bootstrap';
import LineCheckOverlay from './LineCheckOverlay';
import { trackEvent, trackGADatalayerEvent, trackLineEvent } from '../../utils/AnalyticsUtils';
import {
  AUTHCOOKIE,
  CHANGE,
  CHECKADDRESS,
  GAEVENT,
  LINEADDRESS,
  LINECHECKSTART,
  LINETABLERESULT,
  SBLINECHECKRESULT,
  SBLINECHECKSTART,
  TYPE,
  VIEW
} from '../../Analytics/AnalyticsConstants';
import Cookies from 'js-cookie';
import { viewport } from '../../utils/utils';
import { fetchLineCheck } from './LinecheckService';
import Styles from './LineCheckV3.module.scss';
import FalconMessage from '../FalconMessage/FalconMessage';
const LineCheckV3: FC<any> = ({
  content,
  shippingAddress,
  onSuccess,
  productName,
  handleModalClick,
  setShowModal,
  editClick,
  productId
}) => {
  const [isAddressNotFilled, setAddressNotFilled] = useState<boolean>(false); // ??
  const addressRef = useRef<HTMLInputElement>(null);
  const [state, setState] = useState<any>({
    enableCheckaddress: false // if something is elected from dropdown making the btn enable
  });
  const [selectedAddress, setupdateSelectedAddress] = useState<any>();
  const [linecheckResponse, setlinecheckResponse] = useState<any>();
  const [FetchingLineCheck, setFetchingLineCheck] = useState<boolean>(false);
  const [lineCheckContent, setLinecheckContent] = useState<any>();
  const [buttonClick, setButtonClick] = useState<boolean>(false);
  const [indivialOpen, setIndivialOpen] = useState<{indOpen:boolean;indErrorOpen:boolean}>({
    indOpen: false,
    indErrorOpen: false
  });

  const [individualLineCheck, setIndividualLineCheck] = useState<any>({
    openIndividualLineCheck: false,
    availabilityCheckClicked: false
  });
  const [apiError, setApiError] = useState<boolean>(false);
  const viewPort = viewport();
  const flagFromSB = lineCheckContent?.shouldAutomateLineCheck;
  const today = new Date();
  const updatedate = new Date(linecheckResponse?.plannedUpgrade?.date);
  const timedifference = updatedate.getTime() - today.getTime();
  const daydifference = timedifference / (1000 * 3600 * 24);
  const speedupdate = daydifference > 0;
  const [popup, setPopup] = useState<boolean>(false);
  const handleSelection = (data: any, individuallinecheck: any) => {
    setIndividualLineCheck(individuallinecheck);
    setlinecheckResponse(' ');
    setupdateSelectedAddress(data);
    if (
      data?.postCode !== '' &&
      data.city !== '' &&
      data.houseNumber !== '' &&
      data.street !== '' &&
      data.concatedAddress !== ''
    ) {
      setState((prevState: any) => ({
        ...prevState,
        enableCheckaddress: true
      }));
    } else {
      setState((prevState: any) => ({
        ...prevState,
        enableCheckaddress: false
      }));
    }
  };
  const handleChange = () => {
    if (state?.enableCheckaddress)
      setState((prevState: any) => ({
        ...prevState,
        enableCheckaddress: false
      }));
    else setAddressNotFilled(false);
  };
  const EditButtonClick = (): void => {
    setButtonClick(false);
    typeof window != 'undefined' && localStorage.removeItem('lineCheckResponse');
    deleteCookie('chAddressJson');
    deleteCookie('one-commerce-linecheckcorrelationid');
    trackEvent(LINEADDRESS, CHANGE, TYPE);
    setState((prevState: any) => ({
      ...prevState,
      enableCheckaddress: true
    
    }));
    //to empty response
    setlinecheckResponse('');
  };
  
  //on click of change address below the order now button of fresh teaser
  useEffect( () => {
    if(editClick && selectedAddress){
      EditButtonClick();
    }
  },[editClick,selectedAddress]);
  
  const btn = (
    <div>
      <span className='mobileTable'>
        <span
          className='changeBtn'
          onClick={EditButtonClick}
          hidden={!linecheckResponse?.eligibleBundle}
        >
          <span className={viewPort !== 'mobile' ? Styles['changeTxts'] : Styles['changeTxt']}>
            {viewPort === 'mobile' ? lineCheckContent?.changeTextMob : lineCheckContent?.changeText}
          </span>
        </span>
      </span>
    </div>
  );
  const checkAddress = () => {
    setButtonClick(true);
    if (state.enableCheckaddress || (selectedAddress && Object.keys(selectedAddress).length > 0)) {
      setFetchingLineCheck(true);
      deleteCookie('chAddressJson');
      setCookie(
        'chAddressJson',
        JSON.stringify({
          addressValue: selectedAddress?.concatedAddress,
          selectedAdd: selectedAddress
        }),
        { path: '/', maxAge: 24 * 60 * 60 * 3 }
      );
      trackEvent(LINECHECKSTART, CHECKADDRESS, TYPE);
      trackGADatalayerEvent(GAEVENT, SBLINECHECKSTART, {
        input: `${selectedAddress?.postCode}| ${selectedAddress?.city}`,
        selection: lineCheckContent?.buttonvalue
      });
      if (selectedAddress && Object.keys(selectedAddress).length > 0) {
        fetchLineCheck(selectedAddress)
          .then((res: any) => {
            localStorage.setItem('LinecheckCall', 'true');
            setFetchingLineCheck(false), setlinecheckResponse(res);
            setApiError(false);
            if (viewPort === 'mobile' && individualLineCheck.openIndividualLineCheck) {
              setPopup(true);
            }
          })
          .catch((err: any) => {
            // eslint-disable-next-line no-console
            console.log(err);
            setApiError(true);
            setIndividualLineCheck({ ...individualLineCheck, availabilityCheckClicked: false });
            if (viewPort === 'mobile' && individualLineCheck.openIndividualLineCheck) {
              setPopup(true);
            }
          });
      }
    } else {
      setAddressNotFilled(true);
      addressRef.current?.focus();
      if (viewPort === 'mobile') {
        setPopup(false);
      }
    }
  };
  useEffect(() => {
    try {
      let addressData: any = getCookie('chAddressJson');
      const correlationIdFromCookie = getCookie('one-commerce-linecheckcorrelationid');
      try {
        addressData = addressData && JSON.parse(addressData);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('invalid address json');
      }
      //Automates the line check procedure if flag is set in sb AND userLogged in AND address is not there.
      let authData: any = getCookie(AUTHCOOKIE);
      try {
        authData = authData && JSON.parse(authData);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('invalid AuthCookie json');
      }
      if (addressData) {
        setState((prevState: any) => ({
          ...prevState,
          enableCheckaddress: false
        }));
        setupdateSelectedAddress(addressData?.selectedAdd);
        // getting line check resposne
        const lineCheckResponse = localStorage.getItem('lineCheckResponse');
        const correlationId = localStorage.getItem('one-commerce-linecheckcorrelationid');
        const payload = {
          eligibleBundle:
            (lineCheckResponse && JSON.parse(lineCheckResponse)?.eligibleBundle) ?? [],
          configEligibleBundle:
            (lineCheckResponse && JSON.parse(lineCheckResponse)?.configEligibleBundle) ?? [],
          maxUploadDownloadSpeed:
            (lineCheckResponse && JSON.parse(lineCheckResponse)?.maxUploadDownloadSpeed) ?? {},
          lineCheckRepsonse:
            linecheckResponse && JSON.parse(linecheckResponse?.originalLinecheckResponse),
          lineCheckCorrelationId: correlationId ?? '',
          plannedUpgrade: (lineCheckResponse && JSON.parse(lineCheckResponse)?.plannedUpgrade) ?? {}
        };
        if (
          lineCheckResponse &&
          correlationIdFromCookie &&
          JSON.parse(lineCheckResponse)?.eligibleBundle &&
          Object.keys(addressData?.selectedAdd).length
        ) {
          setlinecheckResponse(payload);
        }
      }
    } catch {
     //
    }
  }, [lineCheckContent, shippingAddress]);
  useEffect(() => {
    if (content) {
      if (content?.reference?.content?.component === 'lineCheckTemplate') {
        setLinecheckContent(content?.reference?.content?.linecheck[0]);
      } else {
        setLinecheckContent(content?.linecheck?.[0]);
      }
    }
  }, []);
  useEffect(() => {
    if (!linecheckResponse?.eligibleBundle || linecheckResponse?.eligibleBundle.length < 1) {
      setAddressNotFilled(false);
    }
    if (
      linecheckResponse?.eligibleBundle?.length &&
      ((Object.keys(selectedAddress).length !== 0 &&
        linecheckResponse?.maxUploadDownloadSpeed?.maxBandwidthDown !== undefined) ||
        linecheckResponse?.maxUploadDownloadSpeed?.maxBandwidthDown !== undefined)
    ) {
      trackLineEvent(
        `${selectedAddress?.postCode}| ${selectedAddress?.city} | ${selectedAddress?.street} | ${selectedAddress?.houseNumber} |
       ${linecheckResponse?.maxUploadDownloadSpeed?.maxBandwidthUp} | ${linecheckResponse?.maxUploadDownloadSpeed?.maxBandwidthDown}`,
        LINETABLERESULT,
        1,
        Cookies.get('one-commerce-linecheckcorrelationid'),
        VIEW
      );
      trackGADatalayerEvent(GAEVENT, SBLINECHECKRESULT, {
        input: `${selectedAddress?.postCode}| ${selectedAddress?.city}`,
        eligible: ''
      });
    }
  }, [linecheckResponse?.eligibleBundle?.length]);
  const replacePlaceholder: any = (source: string, params: any): string => {
    const text: string = source?.replace(/{\w+}/g, params);
    return text;
  };
  const successRef = useRef<HTMLInputElement>(null);
  const executeScroll = () => {
    setTimeout(() => {
      successRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }, 1000);
  };
  const onClose = () => {
    if (viewPort === 'mobile' && !individualLineCheck.openIndividualLineCheck) {
      checkAddress();
      executeScroll();
    } else if (
      viewPort === 'mobile' &&
      individualLineCheck.openIndividualLineCheck &&
      individualLineCheck.availabilityCheckClicked
    ) {
      checkAddress();
    }
  };
  useEffect(() => {
    if (viewPort === 'mobile' && !individualLineCheck.openIndividualLineCheck) {
      onClose();
    } else if (
      viewPort === 'mobile' &&
      individualLineCheck.openIndividualLineCheck &&
      individualLineCheck.availabilityCheckClicked
    ) {
      onClose();
    }
  }, [selectedAddress]);
  const [errorMessage, setErrorMessage] = React.useState<string>();
  const lineCheckOverlayProps = {
    linecheckResponse,
    eligibleBundle: linecheckResponse?.eligibleBundle,
    lineCheckContent,
    handleSelection,
    isAddressNotFilled,
    name: 'lineCheck',
    onChange: handleChange,
    selectedAddress,
    isFetchingLineCheck: FetchingLineCheck,
    onClose: onClose,
    apiError: apiError,
    setApiError: setApiError,
    setFetchingLineCheck: setFetchingLineCheck,
    setPopup: setPopup,
    content,
    errorMessage,
    EditButtonClick
  };
  const overlay = { ...lineCheckOverlayProps };
  // const handleClick = () => {
  //   if (viewPort === 'mobile') {
  //     addressRef?.current?.focus();
  //     setPopup(true);
  //   }
  // };
  React.useEffect(() => {
    if (linecheckResponse?.eligibleBundle?.length < 1) {
      setErrorMessage(lineCheckContent?.dataText);
    } else {
      setErrorMessage('');
    }
  }, []);
  const openMobileOverlay = () => {
    if (viewPort === 'mobile') {
      setPopup(true);
    }
  };
  useEffect(() => {
    openMobileOverlay();
    window.addEventListener('resize', openMobileOverlay);
  }, [viewPort]);
  const handleCloseClick = () => {
    setShowModal(false);
  };
  useEffect(() => {
    apiError && setFetchingLineCheck(false);
  }, [apiError]);
  
  const isAvailable=linecheckResponse?.eligibleBundle?.includes(productId);
  return (
    <>
      {!popup && viewPort !== 'mobile' && (
        <>
          <div className={`row justify-content-center `} ref={successRef}>
            <div
              className={`${
                linecheckResponse?.eligibleBundle && viewPort === 'mobile'
                  ? Styles['linecheckOverlay']
                  : 'col-12 px-0'
              }`}
            >
              <div
                className={`  ${
                  isAddressNotFilled && !linecheckResponse?.eligibleBundle ? `gradientborder` : ''
                } ${viewPort !== 'mobile' && Styles['maincontainerMob']}`}
              >
                {/* <div className={'input'}> */}
                {!FetchingLineCheck && (
                  <div
                    className={`${
                      !linecheckResponse?.eligibleBundle && !isAvailable &&
                      viewPort != 'mobile' &&
                      `row ${Styles['inputrows']}`
                    }  ${
                      viewPort != 'mobile' &&
                      linecheckResponse?.eligibleBundle &&
                      (errorMessage ||
                      (!errorMessage && linecheckResponse?.eligibleBundle?.length > 1 && isAvailable)
                        ? `row ${Styles['inputrow-success']}`
                        : `row ${Styles['inputrow-failure']}`)
                    }  `}
                  >
                    {linecheckResponse?.eligibleBundle &&
                      (errorMessage ||
                      (!errorMessage && linecheckResponse?.eligibleBundle?.length > 1 && isAvailable) ? (
                        <img
                          src={lineCheckContent?.linecheckIcons?.[0]?.tick?.filename}
                          height={'32px'}
                          width={'32px'}
                          alt='linecheckIcons'
                        />
                      ) : (
                        <img
                          src={lineCheckContent?.linecheckIcons?.[0]?.notAvailableIcon?.filename}
                          height={'32px'}
                          width={'32px'}
                          alt='linecheckIcons'
                        />
                      ))}

                    {(lineCheckContent?.linecheckTitle ||
                      lineCheckContent?.successLinecheckTitle) && (
                      <>
                        <h4
                          className={`${
                            !linecheckResponse?.eligibleBundle
                              ? Styles['linechecktitle']
                              : Styles['linechecktitle-success']
                          } `}
                        >
                          {!FetchingLineCheck &&
                          linecheckResponse?.eligibleBundle &&
                          linecheckResponse?.eligibleBundle
                            ? !isAvailable
                              ? lineCheckContent?.noConnectionTitle.replace('{0}', productName)
                              : lineCheckContent?.successLinecheckTitle.replace('{0}', productName)
                            : lineCheckContent?.linecheckTitle.replace('{0}', productName)}
                        </h4>
                      </>
                    )}
                    {
                      <span onClick={handleCloseClick} className={Styles['closeIcon']}>
                        <img
                          width={14}
                          height={14}
                          alt='close'
                          src={lineCheckContent?.linecheckIcons?.[0]?.close?.filename}
                        />
                      </span>
                    }
                    {!linecheckResponse?.eligibleBundle ? (
                      <>
                        <div className={Styles['horizontalDivider']} />
                        <div className={`col-1 px-0 ${Styles['homeicon-wrapper']}`}>
                          {!linecheckResponse?.eligibleBundle ? (
                            <img
                              src={lineCheckContent?.linecheckIcons?.[0]?.home?.filename}
                              height={`${viewPort === 'mobile' ? '26px' : '48px'}`}
                              width={`${viewPort === 'mobile' ? '26px' : '48px'}`}
                              alt={'home'}
                              className={Styles['homeicon']}
                            />
                          ) : (
                            <></>
                          )}
                        </div>
                        <div
                          className={`col-lg-8 col-md-8 col-sm-8 ${
                            viewPort === 'mobile' &&
                            (!linecheckResponse?.eligibleBundle ? 'col-9' : 'col-12')
                          } px-0 ${Styles['input-container']}`}
                        >
                          <div>
                            <LineCheckInput
                              content={lineCheckContent}
                              parentCallback={handleSelection}
                              parentAddress={selectedAddress?.concatedAddress}
                              ref={addressRef}
                              isAddressNotFilled={isAddressNotFilled}
                              name='lineCheck'
                              onChange={handleChange}
                              setAddressNotFilled={setAddressNotFilled}
                              apiError={apiError}
                              setApiError={setApiError}
                              setFetchingLineCheck={setFetchingLineCheck}
                              checkAvailability={buttonClick}
                              FetchingLineCheck={FetchingLineCheck}
                              setSelectedAddress={setupdateSelectedAddress}
                              Address={selectedAddress}
                              setIndivialOpen={setIndivialOpen}
                              indivialOpen={indivialOpen}
                            />
                          </div>
                        </div>
                        <div
                          className={`col-lg-3 col-md-3 col-sm-3 col-2 px-0 m-auto ${Styles['checkbutton']}`}
                        >
                          <button
                            name='check address button'
                            type='button'
                            className={`primarybutton`}
                            disabled={
                              indivialOpen?.indOpen
                                ? false
                                : !state?.enableCheckaddress || FetchingLineCheck
                            }
                            hidden={!!linecheckResponse?.eligibleBundle}
                            onClick={checkAddress}
                            style={{ width: '100%', position: 'relative', bottom: '10px' }}
                          >
                            {lineCheckContent?.buttonvalue}
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <Success
                          content={
                            <span data-hj-suppress>
                              {selectedAddress?.concatedAddress}
                              {btn}
                            </span>
                          }
                          isLoading={FetchingLineCheck}
                          uploadDownload={linecheckResponse?.maxUploadDownloadSpeed}
                          textContent={content}
                          eligibleBundle={linecheckResponse?.eligibleBundle}
                          tooltipcontent={lineCheckContent?.speedTooltip}
                          onSuccess={onSuccess}
                          isAvailable={isAvailable}
                        />
                      </>
                    )}
                    {/* falcon message for indivial linecheck */}
                    {indivialOpen?.indErrorOpen &&
                      lineCheckContent?.errorMessageBlok?.length > 0 && (
                        <div className={Styles['falcon-message']}>
                          <FalconMessage content={lineCheckContent?.errorMessageBlok?.[0]} />
                        </div>
                      )}
                  </div>
                )}
                {viewPort !== 'mobile' &&
                FetchingLineCheck &&
                !apiError &&
                addressRef?.current?.value !== '' ? (
                  <div className={Styles['spinnercontainers']}>
                    {
                      <>
                        <div
                          className={`spinner-border ${Styles['spinnersrotate']} `}
                          role='status'
                        ></div>
                        {content?.linecheck?.[0]?.checkServiceText && (
                          <h4 className={Styles['checktextcontainer']}>
                            {content?.linecheck?.[0]?.checkServiceText}
                          </h4>
                        )}
                      </>
                    }
                  </div>
                ) : (
                  ' '
                )}
              </div>
            </div>
          </div>
          {lineCheckContent?.helpText && !addressRef.current?.value && (
            <div className={Styles['helptext']}>
              {!FetchingLineCheck && linecheckResponse?.eligibleBundle
                ? ''
                : lineCheckContent?.helpText}
            </div>
          )}
        </>
      )}
      {viewPort === 'mobile' && popup && (
        <div>
          <LineCheckOverlay
            props={overlay}
            productName={productName}
            handleModalClick={handleModalClick}
            onSuccess={onSuccess}
            setIndivialOpen={setIndivialOpen}
            indivialOpen={indivialOpen}
            setAddressNotFilled={setAddressNotFilled}
            isAvailable={isAvailable}
          />
        </div>
      )}
    </>
  );
};
export default LineCheckV3;
